module.exports = __webpack_public_path__ + "img/tps-ecosystem-sm.34c4302a.png";